/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Feat_Whitelabel_5_TitleInputs */

const en_upgrade_feat_whitelabel_5_title = /** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Whitelabel Sites`)
};

const es_upgrade_feat_whitelabel_5_title = /** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Sitios de Marca Blanca`)
};

const fr_upgrade_feat_whitelabel_5_title = /** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 sites en marque blanche`)
};

const de_upgrade_feat_whitelabel_5_title = /** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Whitelabel-Sites`)
};

const id_upgrade_feat_whitelabel_5_title = /** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Situs Whitelabel`)
};

/** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */
const ja_upgrade_feat_whitelabel_5_title = en_upgrade_feat_whitelabel_5_title;

/** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */
const zh_upgrade_feat_whitelabel_5_title = en_upgrade_feat_whitelabel_5_title;

/** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */
const ar_upgrade_feat_whitelabel_5_title = en_upgrade_feat_whitelabel_5_title;

/** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */
const it_upgrade_feat_whitelabel_5_title = en_upgrade_feat_whitelabel_5_title;

/** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */
const ru_upgrade_feat_whitelabel_5_title = en_upgrade_feat_whitelabel_5_title;

/** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */
const pt_upgrade_feat_whitelabel_5_title = en_upgrade_feat_whitelabel_5_title;

/** @type {(inputs: Upgrade_Feat_Whitelabel_5_TitleInputs) => LocalizedString} */
const ko_upgrade_feat_whitelabel_5_title = en_upgrade_feat_whitelabel_5_title;

/**
* | output |
* | --- |
* | "5 Whitelabel Sites" |
*
* @param {Upgrade_Feat_Whitelabel_5_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_feat_whitelabel_5_title = /** @type {((inputs?: Upgrade_Feat_Whitelabel_5_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Feat_Whitelabel_5_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "es") return es_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "fr") return fr_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "de") return de_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "ja") return ja_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "zh") return zh_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "ar") return ar_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "id") return id_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "it") return it_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "ru") return ru_upgrade_feat_whitelabel_5_title(inputs)
	if (locale === "pt") return pt_upgrade_feat_whitelabel_5_title(inputs)
	return ko_upgrade_feat_whitelabel_5_title(inputs)
});